/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainPushNotificationsTokensPushNotificationPlatformFromJSON, FxIdDomainPushNotificationsTokensPushNotificationPlatformToJSON, } from './FxIdDomainPushNotificationsTokensPushNotificationPlatform';
/**
 * Check if a given object implements the FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs interface.
 */
export function instanceOfFxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs(value) {
    if (!('Game' in value) || value['Game'] === undefined)
        return false;
    if (!('Platform' in value) || value['Platform'] === undefined)
        return false;
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsFromJSON(json) {
    return FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsFromJSONTyped(json, false);
}
export function FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Game': json['Game'],
        'Platform': FxIdDomainPushNotificationsTokensPushNotificationPlatformFromJSON(json['Platform']),
        'Token': json['Token'],
        'ExpirationTime': json['ExpirationTime'] == null ? undefined : (new Date(json['ExpirationTime'])),
    };
}
export function FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsToJSON(json) {
    return FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsToJSONTyped(json, false);
}
export function FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Game': value['Game'],
        'Platform': FxIdDomainPushNotificationsTokensPushNotificationPlatformToJSON(value['Platform']),
        'Token': value['Token'],
        'ExpirationTime': value['ExpirationTime'] == null ? undefined : (value['ExpirationTime'].toISOString()),
    };
}
//# sourceMappingURL=FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs.js.map